import Vue from 'vue'
import {
  Container,
  Header,
  Main,
  Footer,
  Menu,
  Submenu,
  MenuItem,
  Row,
  Col,
  Carousel,
  CarouselItem,
  Button,
  Dialog,
  Card,
  Tabs,
  TabPane,
  Divider,
  Form,
  FormItem,
  Input,
  Popover,
  Select,
  Option,
  Message,
  Upload,
  Pagination,
  Result,
  Table,
  TableColumn,
  Loading
} from 'element-ui'

Vue.use(Container)
Vue.use(Header)
Vue.use(Main)
Vue.use(Footer)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(Row)
Vue.use(Col)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Button)
Vue.use(Dialog)
Vue.use(Card)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Divider)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Popover)
Vue.use(Select)
Vue.use(Option)
Vue.use(Upload)
Vue.use(Pagination)
Vue.use(Result)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Loading)

Vue.prototype.$message = Message
